import { DynamicInputBase } from './dynamic-input-base';

export class DropdownInput extends DynamicInputBase<any> {
  controlType = 'dropdown';
}
